<template>
  <div class="text-center text-lg-right">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <p class="font-15 font-medium mb-0">{{(currentPage - 1) * itemsPerPage + 1}} - {{currentPage * itemsPerPage > totalItems ? totalItems: currentPage * itemsPerPage}} {{$lang.messages.of}} {{totalItems}} {{$lang.messages.data}}</p>
      <div class="d-flex align-items-center">
        <label class="font-15 mr-2 mb-0">{{$lang.messages.rows_per_page}}:</label>
        <div
          class="selectbox-xs text-right custom-select-dd">
          <select class="form-control" @change="setItemsPerPage(itemsPerPage)" v-model="itemsPerPage">
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
          </select>
        </div>
      </div>
    </div>

    <div class="text-center">
      <nav v-if="isShow" aria-label="Page navigation example" class="d-inline-block">
        <ul class="pagination">
          <li class="page-item" :class="{'disabled':(currentPage === 1)}">
            <a class="page-link" @click="setPage(1)" aria-label="Previous">
              <span>{{$lang.messages.first}}</span>
            </a>
          </li>
          <li class="page-item" :class="{'disabled':(currentPage === 1)}">
            <a class="page-link" @click="setPage(currentPage - 1)" aria-label="Previous">
              <span aria-hidden="true">
                <i class="fa fa-arrow-left"></i>
              </span>
              <span class="sr-only">{{$lang.messages.previous}}</span>
            </a>
          </li>

          <li
            v-for="page in pages"
            class="page-item"
            :class="{'active':(currentPage === page )}"
            :key="page">
            <a @click="setPage(page)" class="page-link">{{page}}</a>
          </li>

          <li class="page-item" :class="{'disabled':(currentPage === totalPages)}">
            <a class="page-link" @click="setPage(currentPage + 1)" aria-label="Next">
              <span aria-hidden="true">
                <i class="fa fa-arrow-right"></i>
              </span>
              <span class="sr-only">{{$lang.messages.next}}</span>
            </a>
          </li>
          <li class="page-item" :class="{'disabled':(currentPage === totalPages)}">
            <a class="page-link" @click="setPage(totalPages)" aria-label="Next">
              <span>{{$lang.messages.last}}</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",

  data() {
    return {
      isShow: false,
      currentPage: 1,
      pages: [],
      totalPages: 0,
      totalItems: 0
    };
  },
  props: {
    page: {
      type: Number,
      default: 0,
      validator: page => {
        return page >= 0;
      }
    },
    itemsPerPage: {
      default: 10,
      validator: page => {
        return page >= 0;
      }
    },
    itemsCount: {
      type: Number
    }
  },
  methods: {
    setPage(page) {
      this.$emit("page-change", page);
      this.setCurrentPage(page);
    },
    setTotalCount(items) {
      this.totalItems = Number(items);
      this.totalPages = Math.ceil(Number(items) / this.itemsPerPage);

      if (this.totalPages > 1) {
        this.isShow = true;
        this.setCurrentPage(1);
      } else {
        this.isShow = false;
      }
    },
    setItemsPerPage(itemsPerPage) {
      this.currentPage = 1;
      this.$emit("items-per-page-change", itemsPerPage);
    },
    setCurrentPage(currentPage) {
      this.currentPage = currentPage;
      var startPage, endPage;
      if (this.totalPages <= 5) {
        startPage = 1;
        endPage = this.totalPages;
      } else {
        if (currentPage <= 3) {
          startPage = 1;
          endPage = 5;
        } else if (currentPage + 2 >= this.totalPages) {
          startPage = this.totalPages - 4;
          endPage = this.totalPages;
        } else {
          startPage = currentPage - 2;
          endPage = currentPage + 2;
        }
      }

      this.pages = [];
      for (let i = startPage; i <= endPage; i++) {
        this.pages.push(i);
      }
    }
  },

  created() {
    if (this.itemsCount) {
      this.setTotalCount(this.itemsCount)
    }
  },

  watch: {
    itemsPerPage() {
      if (this.itemsCount) {
        this.setTotalCount(this.itemsCount)
        this.currentPage = this.page
      }
    },
    itemsCount() {
      this.setTotalCount(this.itemsCount)
      this.currentPage = this.page
    }
  }
};
</script>
